/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actiontypes.ALL_ACC_REC_NDC__DETAIL_TABLE:
      return {
        ...state,
        getAllAccRecNDCDetailList: action.getAllAccRecNDCDetailList,
      };
    case actiontypes.NDC_DETAIL:
      return { ...state, ndcDetailList: action.ndcDetailList };
    case actiontypes.ACC_REC_NDC_DETAIL_ALL_FIELD_CLEAR_REDUX:
      return action.payload ? action.payload : {};
    default:
      return state;
  }
};

export default reducer;
